/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

import ClipboardJS from 'clipboard';

/*------------------------------------*\
    COPY TO CLIPBOARD MODULE
\*------------------------------------*/
class CopyToClipboard {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var elem = $(this);

        var hoverText = elem.data('hover-text');
        var originalText = elem.data('original-text');

        var clipboard = new ClipboardJS(self.elem);

        clipboard.on('success', function(e) {
            elem.text(hoverText);
            elem.removeClass('btn-outline-dark');
            elem.addClass('btn-success');

            setTimeout(function() {
                elem.text(originalText);
                elem.removeClass('btn-success');
                elem.addClass('btn-outline-dark');
            }, 2000);
        });
    }
}

export default CopyToClipboard;